export const DealSummaryActionStatus = {
  ACCEPT_BID: 'ACCEPT_BID',
  GRANT_DOCUMENT_ACCESS: 'GRANT_DOCUMENT_ACCESS',
  REVOKE_DOCUMENT_ACCESS: 'REVOKE_DOCUMENT_ACCESS',
  VIEW_MESSAGES: 'VIEW_MESSAGES',
  END_CONVERSATION: 'END_CONVERSATION',
};

export const DealSummaryActionsButtonText = {
  [DealSummaryActionStatus.ACCEPT_BID]: 'Accept bid',
  [DealSummaryActionStatus.GRANT_DOCUMENT_ACCESS]: 'Grant document access',
  [DealSummaryActionStatus.VIEW_MESSAGES]: 'View messages',
  [DealSummaryActionStatus.END_CONVERSATION]: 'End conversation',
};

export const DealSummaryActionsDropdownOptions = [
  { text: DealSummaryActionsButtonText[DealSummaryActionStatus.GRANT_DOCUMENT_ACCESS], value: DealSummaryActionStatus.GRANT_DOCUMENT_ACCESS },
  { text: DealSummaryActionsButtonText[DealSummaryActionStatus.VIEW_MESSAGES], value: DealSummaryActionStatus.VIEW_MESSAGES },
  { text: DealSummaryActionsButtonText[DealSummaryActionStatus.END_CONVERSATION], value: DealSummaryActionStatus.END_CONVERSATION },
];